/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type AddAdvancedPatientHistoryEntryMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  date: Types.Scalars['String']['input']
  type: Types.PatientHistoryType
  value: Types.Scalars['JSONObject']['input']
  fileIDs?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>
  references?: Types.InputMaybe<Types.PatientHistoryReferencesInput>
}>

export type AddAdvancedPatientHistoryEntryMutation = {
  __typename?: 'Mutation'
  addPatientHistory:
    | { __typename?: 'CommonPatientHistory'; entryID: string }
    | { __typename?: 'FinancialEligibilityPatientHistory'; entryID: string }
    | { __typename?: 'LabOrderPatientHistory'; entryID: string }
    | { __typename?: 'VideoCallPatientHistory'; entryID: string }
}

export const AddAdvancedPatientHistoryEntryDocument = gql`
  mutation addAdvancedPatientHistoryEntry(
    $uid: ID!
    $date: String!
    $type: PatientHistoryType!
    $value: JSONObject!
    $fileIDs: [ID!]
    $references: PatientHistoryReferencesInput
  ) {
    addPatientHistory(uid: $uid, date: $date, type: $type, value: $value, fileIDs: $fileIDs, references: $references) {
      entryID
    }
  }
`
export type AddAdvancedPatientHistoryEntryMutationFn = Apollo.MutationFunction<
  AddAdvancedPatientHistoryEntryMutation,
  AddAdvancedPatientHistoryEntryMutationVariables
>

/**
 * __useAddAdvancedPatientHistoryEntryMutation__
 *
 * To run a mutation, you first call `useAddAdvancedPatientHistoryEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdvancedPatientHistoryEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdvancedPatientHistoryEntryMutation, { data, loading, error }] = useAddAdvancedPatientHistoryEntryMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      date: // value for 'date'
 *      type: // value for 'type'
 *      value: // value for 'value'
 *      fileIDs: // value for 'fileIDs'
 *      references: // value for 'references'
 *   },
 * });
 */
export function useAddAdvancedPatientHistoryEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddAdvancedPatientHistoryEntryMutation,
    AddAdvancedPatientHistoryEntryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AddAdvancedPatientHistoryEntryMutation, AddAdvancedPatientHistoryEntryMutationVariables>(
    AddAdvancedPatientHistoryEntryDocument,
    options
  )
}
export type AddAdvancedPatientHistoryEntryMutationHookResult = ReturnType<
  typeof useAddAdvancedPatientHistoryEntryMutation
>
export type AddAdvancedPatientHistoryEntryMutationResult = Apollo.MutationResult<AddAdvancedPatientHistoryEntryMutation>
export type AddAdvancedPatientHistoryEntryMutationOptions = Apollo.BaseMutationOptions<
  AddAdvancedPatientHistoryEntryMutation,
  AddAdvancedPatientHistoryEntryMutationVariables
>
